import React from "react";
import DepreciationChargesGenericSkeleton from "./DepreciationChargesGenericSkeleton";

function DepreciationChargesDetailSkeleton() {
  return (
    <>
      <DepreciationChargesGenericSkeleton />
    </>
  );
}

export default DepreciationChargesDetailSkeleton;
